import { useQuery } from '@tanstack/vue-query';
import type { GalleriesResponse, GalleryResponse } from '~/types/types';

export function usePublicGalleries(portal: string) {
   const config = useRuntimeConfig();
   const baseUrl = config.public.lmsApiBaseurl;
   const headers = { 'X-LMS-Requester': config.public.siteDomain as string };

   const {
      data: galleriesData,
      isLoading,
      error,
   } = useQuery({
      queryKey: ['public-galleries', portal],
      queryFn: async (): Promise<GalleriesResponse> => {
         // eslint-disable-next-line no-undef
         return await $fetch<GalleriesResponse>(
            `${baseUrl}portals/${portal}/galleries`,
            { headers }
         );
      },
      staleTime: 30 * 60 * 1000,
      gcTime: 60 * 60 * 1000,
   });

   return {
      galleriesData,
      isLoading,
      error,
   };
}

export function usePublicGallery(portal: string, slug: string) {
   const config = useRuntimeConfig();
   const baseUrl = config.public.lmsApiBaseurl;
   const headers = { 'X-LMS-Requester': config.public.siteDomain as string };

   const {
      data: galleryData,
      isLoading,
      error,
   } = useQuery({
      queryKey: ['public-gallery', portal, slug],
      queryFn: async (): Promise<GalleryResponse> => {
         // eslint-disable-next-line no-undef
         return await $fetch<GalleryResponse>(
            `${baseUrl}portals/${portal}/galleries/${slug}`,
            { headers }
         );
      },
      staleTime: 30 * 60 * 1000,
      gcTime: 60 * 60 * 1000,
   });

   return {
      galleryData,
      isLoading,
      error,
   };
}
